<template>
  <div class="mp-skeleton-data-list">
    <ul v-for="(data, index) in dataList" :key="index">
      <li
        :class="
          index !== 0 && index % 5 === 0 && index !== dataList.length
            ? 'dataItem dataItem_divider'
            : 'dataItem'
        "
      >
        <div class="dot_title">·</div>
        <div class="content_title"></div>
        <div class="time"></div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.mp-skeleton-data-list {
  li {
    list-style-type: disc;
    color: #c5c8ce;
    cursor: pointer;
    animation-duration: 1.5s;
    animation-name: blink;
    animation-iteration-count: infinite;
  }
  ul > a {
    color: inherit;
  }
  .dataItem {
    padding: 5px 0;
    margin-right: 10px;
    min-height: 36px;
    display: flex;
    justify-content: space-between;
    font-family: "微软雅黑";
    font-size: 14px;
    width: 100%;
    .dot_title {
      font-weight: bolder;
    }
    .content_title {
      background: #e8eaec;
      width: 75%;
      border-radius: 2px;
    }
    .time {
      width: 20%;
      min-height: 20px;
      background: #e8eaec;
      border-radius: 2px;
    }
  }
  .dataItem_divider {
    padding-top: 10px;
    margin-top: 10px;
    border-top: 1px solid #e8eaec;
    background-position: 6px 28px;
  }
}
@keyframes blink {
  0% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}

@keyframes flush {
  0% {
    left: -100%;
  }

  50% {
    left: 0;
  }

  100% {
    left: 100%;
  }
}
</style>
